/** The knowledge base (plan E07-T04): the tenant's collections, and a new one. */
import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useState } from "react";
import { Page, Section, useApiQuery } from "../app/Page";
import { useCan } from "../app/session";
import { useFormat, useT } from "../i18n";
import { Button } from "../ui/Button";
import { Empty } from "../ui/states";
import { Table } from "../ui/Table";
import { embedderLabel, NewCollection } from "./parts";

export function KnowledgePage() {
  const t = useT();
  const format = useFormat();
  const canWrite = useCan("agents:write");
  const [adding, setAdding] = useState(false);
  const collections = useApiQuery("knowledge", (api) => api.GET("/v1/knowledge/collections", { params: { query: { limit: 100 } } }));
  const create = canWrite && !adding && (
    <Button onClick={() => setAdding(true)}>
      <Plus size={16} aria-hidden="true" />
      {t("knowledge.new")}
    </Button>
  );
  return (
    <Page title={t("nav.knowledge")} description={t("knowledge.description")} actions={create}>
      {adding && <NewCollection onDone={() => setAdding(false)} />}
      <Section query={collections}>
        {(page) =>
          page.data.length === 0 ? (
            adding ? null : (
              <Empty title={t("knowledge.empty")}>
                <p>{t("knowledge.emptyBody")}</p>
                {create}
              </Empty>
            )
          ) : (
            <Table
              caption={t("knowledge.collections")}
              rows={page.data}
              rowKey={(c) => c.id}
              columns={[
                {
                  header: t("knowledge.name"),
                  cell: (c) => (
                    <Link to="/knowledge/$collectionId" params={{ collectionId: c.id }} className="font-medium text-[var(--color-primary)] underline">
                      {c.name}
                    </Link>
                  ),
                },
                { header: t("knowledge.descriptionLabel"), cell: (c) => c.description || "—" },
                { header: t("knowledge.embedder"), cell: (c) => <span className="font-mono text-xs">{embedderLabel(c.embedder)}</span> },
                { header: t("knowledge.documents"), cell: (c) => format.number(c.documents) },
                { header: t("knowledge.chunks"), cell: (c) => format.number(c.chunks) },
                { header: t("knowledge.updated"), cell: (c) => format.dateTime(c.updated_at) },
              ]}
            />
          )
        }
      </Section>
    </Page>
  );
}
